__webpack_require__.p = "/awesome-qualcomm-developer/";